import { PERFORMANCE_EXPECTATIONS_TYPE } from 'global/constants';
import sortByDisplayOrder from './sort-by-display-order';

/**
 * Sorts dimension keys according to the standard PE dimension order:
 * DCI, SEP, CCC, ENG, NOS. Keys not in this list appear at the end
 * in their original order.
 *
 * @param keys - Array of dimension keys to sort
 * @returns Sorted array of dimension keys
 */
export default function sortPerformanceExpectationDimensions(
  keys: string[]
): string[] {
  return sortByDisplayOrder(keys, PERFORMANCE_EXPECTATIONS_TYPE);
}
